import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, SortDirection } from '@angular/material/sort';
import { Router } from '@angular/router';
import { StateManagerService } from 'src/app/common/services/state.manager.service';
import { ShopPayrollSettingsModel } from './model/shop-payroll-settings.model';
import { ShopPayrollSettingsService } from './shop-payroll-settings.service';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { ColumnFilter, RequestData } from 'src/app/common/models/request-data.model';
import { FilterListItemModel, SearchFilterComponent, SearchParam } from 'src/app/common/components/search-filter/search-filter.component';
import { PermissionService } from 'src/app/auth/permission.service';


@Component({
  selector: 'app-shop-payroll-settings',
  templateUrl: './shop-payroll-settings.component.html',
  styleUrls: ['./shop-payroll-settings.component.scss'],
  standalone: false
})
export class ShopPayrollSettingsComponent {
  shopPayrollList: ShopPayrollSettingsModel[] = [];

  showSearch: boolean = false;
  isLoading = true;
  IsDownloading = false;

  filter: FilterListItemModel[] = [
    {
      title: "Code",
      column: "shop.code",
    },
    {
      title: "Name",
      column: "shop.name",
    },
    {
      title: "Group",
      column: "payroll_group.code",
    },

    {
      title: "Group Name",
      column: "payroll_group.name",
    },
    {
      title: "Cost Code",
      column: "cost_code",
    }
  ];
  displayedColumns = ['code', 'name', 'group_code', 'group_name', 'cost_code', 'action'];
  pagingData = { length: 0, pageSize: 10, pageIndex: 0 };

  isHandset: boolean = false;
  selectedItem?: ShopPayrollSettingsModel;
  showSummaryPanel: boolean = false;
  selection = new SelectionModel<ShopPayrollSettingsModel>(true, []);
  dataSource = new MatTableDataSource(this.shopPayrollList);

  columnSortData: { column: string, order: SortDirection }[] = [];
  searchColumFilter: any = {};

  @ViewChild(MatSort) sort!: MatSort;
  permission: any;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private stateManagerService: StateManagerService,
    public dialog: MatDialog,
    private snackBarService: SnackBarService,
    private router: Router,
    private shopPayrollService: ShopPayrollSettingsService,
    private permissionService: PermissionService
  ) {
    this.permission = this.permissionService.getPagePermission('payroll_settings');

    this.shopPayrollList = [];
  }

  ngOnInit(): void {
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((state: BreakpointState) => {
      this.isHandset = state.matches;
    });
    this.loadData();
  }
  /**
* Creates the column filter conditions based on search criteria
* @returns Filter condions for columns
*/
  getSearchParam(): SearchParam {

    return this.searchColumFilter;
  }
  /**
     * Builds the request data to be send to API
     * @returns Request Data
     */
  buildRequestData(): RequestData {
    let searchParam = this.getSearchParam();
    let requestData: RequestData = {
      search: {
        filters: {
          simpleSearch: searchParam.freeSearch,
          advSearch: [
            ...(searchParam.advSearch || []),
            ...this.getDefaultSearchParams(searchParam.advSearch),
          ],
          scope: {
            limit: this.pagingData.pageSize,
            offset: (this.pagingData.pageIndex * this.pagingData.pageSize),
          }
        },
        sort: this.getSort(),
      }
    };

    return requestData;
  }

  /**
   * Check and apply default filter for is_system = 0.
   **/
  getDefaultSearchParams(searchFilter: any): ColumnFilter[] {
    var defFilter: any = [];
    if (
      searchFilter == undefined ||
      !searchFilter.some((sf: any) => sf.column == "shop.is_system")
    ) {
      defFilter.push({
        column: "shop.is_system",
        operator: "=",
        value: "0",
      });
    }
    return defFilter;
  }
  setDataSource(shopPayrollList: ShopPayrollSettingsModel[]) {
    this.shopPayrollList = shopPayrollList;
    this.dataSource = new MatTableDataSource(shopPayrollList);
    this.dataSource.sort = this.sort;
  }

  loadData(): void {
    this.isLoading = true;
    let requestData = this.buildRequestData();

    this.shopPayrollService.getList(requestData).subscribe(response => {
      if (response.status === 'SUCCESS') {
        this.setDataSource(response.data.shop_payroll_settings);
        this.pagingData.length = response.data.total_count;
        if (this.pagingData.length === 0) {
          this.selectedItem = undefined;
          this.snackBarService.openSnackBar({
            message: 'No data found. Please remove or change the filter if any.',
            title: 'No Data!!!',
            type: 'warn'
          });
        } else {
          this.onRowSelected(this.shopPayrollList[0]);
          this.stateManagerService.setState(this.constructor.name, requestData);
        }
      } else {
        this.snackBarService.openSnackBar({
          message: response.message,
          title: 'Failed!!!',
          type: 'error'
        });
      }
      this.isLoading = false;
    });
  }

  getSort() {
    return this.columnSortData;
  }

  setSortColumn(column: string, direction: SortDirection): void {
    this.columnSortData.length = 0;
    this.columnSortData.push({ column, order: direction });
    this.sort.sort({
      id: column,
      start: direction,
      disableClear: false,
    });
  }

  sortData($event: any): void {
    this.setSortColumn($event.active, $event.direction);
    this.loadData();
  }

  onFilterApplied(columFilter: any): void {
    this.searchColumFilter = columFilter;
    this.loadData();
  }

  onRowSelected(item: ShopPayrollSettingsModel): void {
    this.selectedItem = item;
    this.showSummaryPanel = true;
  }

  onEdit(item: ShopPayrollSettingsModel): void {
    this.router.navigate(['payroll/shop-payroll-settings-edit', item.shop_id]);
  }

  onDelete(item: ShopPayrollSettingsModel): void {
    const message = `Are you sure, you want to delete ${item.cost_code}?`;
    const dialogData = new ConfirmDialogModel("Confirm Deletion", message);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this.shopPayrollService.delete(item).subscribe({
          next: (response) => {
            if (response.status === 'SUCCESS') {
              this.snackBarService.openSnackBar({
                type: 'success',
                title: 'Deleted',
                message: `The record for ${item.cost_code} has been deleted successfully.`
              });
              this.loadData();
            } else {
              this.snackBarService.openSnackBar({
                message: response.message,
                title: 'Failed!!!',
                type: 'error'
              });
            }
          },
          error: () => {
            this.snackBarService.openSnackBar({
              message: 'Failed to delete. Connection to the server failed',
              title: 'Failed!!!',
              type: 'error'
            });
          }
        });
      }
    });
  }

  onePageEvent(event: any): void {
    this.pagingData.pageIndex = event.pageIndex;
    this.pagingData.pageSize = event.pageSize;
    this.loadData();
  }

  addClicked(): void {
    this.router.navigate(['payroll/shop-payroll-settings-edit', 0]);
  }

  exportClicked() {
    this.isLoading = true;
    const requestData = {
      pageIndex: this.pagingData.pageIndex,
      pageSize: this.pagingData.pageSize,
      sort: this.getSort(),
      filters: this.searchColumFilter
    };
    this.IsDownloading = true;
    this.shopPayrollService.downloadExcel(requestData)
      .subscribe({
        next: blob => {
          this.IsDownloading = false;
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'shop_payroll_settings.csv';
          link.click();
          window.URL.revokeObjectURL(url);
          this.isLoading = false;
        },
        error: error => {
          this.IsDownloading = false;
          this.snackBarService.openSnackBar({
            message: 'Failed to export. Connection to the server failed',
            title: 'Failed!!!',
            type: 'error'
          });
          this.isLoading = false;
        }
      });
  }
}
